var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4.5V14C14 15.1046 13.1046 16 12 16V15C12.5523 15 13 14.5523 13 14V4.5H11C10.1716 4.5 9.5 3.82843 9.5 3V1H4C3.44772 1 3 1.44772 3 2V11H2V2C2 0.89543 2.89543 0 4 0H9.5L14 4.5ZM3.52734 11.85H2.63379L1.81055 13.2885H1.77539L0.943359 11.85H0.0117188L1.23926 13.8334L0 15.849H0.861328L1.71387 14.434H1.74902L2.59863 15.849H3.50684L2.25293 13.8568L3.52734 11.85ZM4.48125 15.849V13.1889H4.51934L5.47148 15.348H5.98711L6.9334 13.1889H6.97148V15.849H7.68633V11.85H6.88652L5.74687 14.4457H5.72051L4.58086 11.85H3.7752V15.849H4.48125ZM9.19102 15.1752H10.8873V15.849H8.4V11.85H9.19102V15.1752Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXml);
export default __webpack_public_path__ + "static/media/XML.7ee91817df62d920f28dbac8026ad895.svg";
export { ForwardRef as ReactComponent };